import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from '../../../environments/environment';

@Injectable({
    providedIn: 'root',
  })

export class IcalendarService {
    private apiUrlImportantDates = `${environment.apiConfig.uri}/calendar/fetch-ical-important-dates`;
    private apiUrlAnniversaries = `${environment.apiConfig.uri}/calendar/fetch-ical-anniversaries`;
    private apiUrlBday = `${environment.apiConfig.uri}/calendar/fetch-ical-bday`;

    constructor(private http: HttpClient) {}

    fetchIcalImportantDates(): Observable<any> {
        return this.http.get<any>(this.apiUrlImportantDates);
    }

    fetchIcalAnniversaryData(): Observable<any> {
        return this.http.get<any>(this.apiUrlAnniversaries);
    }

    fetchIcalBdayData(): Observable<any> {
        return this.http.get<any>(this.apiUrlBday);
    }
}